// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/veer-and-back.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/veer-and-back/veer-and-back.js';

mount([g0]);
